import './RangeSlider.scss';

const RangeSlider = (props) => {
    // console.log('RangeSlider props: ', props);
    return (
        <div className='fl-row compact grow'>
            <div className='v2__range-slider-holder'>
                <div className="fill" style={{ width: `${(((((props?.value < props?.max) ? props?.value : props?.max) - props?.min) ?? 0) / ((props?.max - props?.min) ?? 100)) * 100}%` }}></div>
                <input
                    type="range"
                    className="v2__range-slider"
                    min={props.min ?? 0}
                    max={props.max ?? 100}
                    value={props.value ?? 0}
                    onChange={props.onChange ?? ((e) => {/* console.log('v2 Slider onChange: ', e) */})}
                />
            </div>
            {props.showValue &&
                <input
                    type="number"
                    className="v2-module-input v2__slider-input-val"
                    min={props.min ?? 0}
                    max={props.max ?? 100}
                    value={props.value ?? 0}
                    onChange={props.onChange ?? ((e) => {/* console.log('v2 Slider number input onChange: ', e) */})}
                />
            }
        </div>
    );
};

export default RangeSlider;
